import { Theme } from '@emotion/react';
import { a11y } from './a11y';
import { always } from './always';
import { backgroundColorLight, backgroundColorDark } from './backgroundColor';
import { colors } from './colors';
import { contentLight, contentDark } from './content';
import { fontStyle } from './fontStyle';
import { layout } from './layout';
import { mediaQuery } from './mediaQuery';
import { mixins } from './mixins';
import { point } from './point';
import { stroke } from './stroke';
import { themeColorLight, themeColorDark } from './themeColor';
import { zIndex } from './zIndex';

export const LightTheme: Theme = {
  colors,
  fontStyle,
  content: contentLight,
  backgroundColor: backgroundColorLight,
  themeColor: themeColorLight,
  mediaQuery,
  mixins,
  a11y,
  zIndex,
  layout,
  always,
  point,
  stroke,
} as const;

export const DarkTheme: Theme = {
  colors,
  fontStyle,
  content: contentDark,
  backgroundColor: backgroundColorDark,
  themeColor: themeColorDark,
  mediaQuery,
  mixins,
  a11y,
  zIndex,
  layout,
  always,
  point,
  stroke,
} as const;
